// Add this at the very top of index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';  // Custom styles if any
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';  // Bootstrap styles
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
const isOldBrowser = () => {
    const ua = navigator.userAgent;
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    if (isIOS) {
      const match = ua.match(/OS (\d+)_(\d+)/);
      if (match) {
        const version = parseInt(match[1], 10);
        return version < 12;
      }
    }
    return false;
  };
  
  if (isOldBrowser()) {
    // Log some debug info
    console.log('Browser Info:', {
      userAgent: navigator.userAgent,
      vendor: navigator.vendor,
      platform: navigator.platform
    });
  }
// Add this at the top of your index.js file
if (!window.ResizeObserver) {
    window.ResizeObserver = class ResizeObserver {
      constructor(callback) {
        this.callback = callback;
        this.observables = new Map();
        // Use a more basic approach for older browsers
        this.interval = setInterval(() => {
          this.observables.forEach((dimensions, element) => {
            const newWidth = element.offsetWidth;
            const newHeight = element.offsetHeight;
            if (dimensions.width !== newWidth || dimensions.height !== newHeight) {
              dimensions.width = newWidth;
              dimensions.height = newHeight;
              this.callback([{
                target: element,
                contentRect: {
                  width: newWidth,
                  height: newHeight
                }
              }]);
            }
          });
        }, 1000); // Check every second
      }
  
      observe(element) {
        if (!this.observables.has(element)) {
          this.observables.set(element, {
            width: element.offsetWidth,
            height: element.offsetHeight
          });
        }
      }
  
      unobserve(element) {
        this.observables.delete(element);
      }
  
      disconnect() {
        clearInterval(this.interval);
        this.observables.clear();
      }
    };
  }

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);